import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { useLocation, Link } from 'react-router-dom';
//import SidebarData from '../sidebars/sidebardata/SidebarData';

const BreadCrumbs = () => {
  const location = useLocation();
  const firstUrl = location.pathname.split('/')[1];
  const secondUrl = location.pathname.split('/')[2];
  console.log(firstUrl, secondUrl);
  return (
    <>
      {/*<h4 className="text-capitalize">{secondUrl ? `${secondUrl}` : `${firstUrl}`}</h4>
      <Breadcrumb>
        <BreadcrumbItem to="/" tag={Link} className="text-decoration-none link-info fw-normal">
          Home
        </BreadcrumbItem>
        {firstUrl ? <BreadcrumbItem active>{firstUrl}</BreadcrumbItem> : ''}
        {secondUrl ? <BreadcrumbItem active>{secondUrl}</BreadcrumbItem> : ''}
      </Breadcrumb>*/}

      <div className="container-fluid m-0 p-0 display-none">
        <div className="row">
          <h4 className="col-6 text-capitalize text-left">
            {secondUrl ? `${secondUrl}` : `${firstUrl}`}
          </h4>
          <div className="col-6 text-right">
            <Breadcrumb className="d-inline-block">
              <BreadcrumbItem
                to="/"
                tag={Link}
                className="text-decoration-none link-info fw-normal"
              >
                Home
              </BreadcrumbItem>
              {firstUrl ? <BreadcrumbItem active>{firstUrl}</BreadcrumbItem> : ''}
              {secondUrl ? <BreadcrumbItem active>{secondUrl}</BreadcrumbItem> : ''}
            </Breadcrumb>
          </div>
        </div>
      </div>
    </>
  );
};

export default BreadCrumbs;
